import React, { Component } from 'react';
import './css/App.css';
import Player from './Player.js';
import playerData from './data/players.json'

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      initialPlayerData: [],
      playerData: []
    };
    this.filterByTag = this.filterByTag.bind(this);
  }

  componentDidMount() {
    const initialPlayerData = playerData.slice(0, 50);

    this.setState({
      initialPlayerData: initialPlayerData,
      playerData: initialPlayerData
    });
  }

  filterByTag(event) {
    const tags = event.target.value.split(",").map((t) => {
      return t.trim().toLowerCase();
    });
    const updatedList = this.state.initialPlayerData.filter((p) => {
      for (var i = 0; i < tags.length; i++) {
        if (p.tag.toLowerCase().search(tags[i]) !== -1) {
          return true;
        }
      }
      return false;
    });

    this.setState({
      playerData: updatedList
    });
  }

  render() {
    const playersView = this.state.playerData.map((p) =>
      <Player key={p.player_id} tag={p.tag} ranking_number={p.ranking_number}
              placements={p.placements} setWins={p.set_wins}
              setLosses={p.set_losses}/>);
    return (
      <div>
        <header className="App-header">
          <h1 className="App-title">smashstats</h1>
        </header>
        <div id="content">
          <fieldset>
            <input type="text" placeholder="MkLeo, Nairo, Mr.R..."
                   onChange={this.filterByTag}/>
          </fieldset>
          <div id="players">
            {playersView}
          </div>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js